import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyC7BYzoxkbAxkiD2pSKXdbolSMDHmXxcqg",
    authDomain: "sksfans-c7f40.firebaseapp.com",
    projectId: "sksfans-c7f40",
    storageBucket: "sksfans-c7f40.firebasestorage.app",
    messagingSenderId: "713716391527",
    appId: "1:713716391527:web:3054f6b539a8336228fec2",
    measurementId: "G-XZKN35DXRD"
};

const app = initializeApp(firebaseConfig);

export default app;